var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7979 7.9628H11.9504C11.7748 7.9628 11.6325 8.1051 11.6325 8.28062V12.1447C11.6325 12.3498 11.4656 12.5167 11.2605 12.5167H3.85501C3.64995 12.5167 3.48316 12.3498 3.48316 12.1447V4.73934C3.48316 4.5342 3.64995 4.36728 3.85501 4.36728H7.91697C8.09249 4.36728 8.23479 4.22498 8.23479 4.04946V3.20194C8.23479 3.02641 8.09249 2.88411 7.91697 2.88411H3.85501C2.83214 2.88411 2 3.71638 2 4.73934V12.1448C2 13.1677 2.83218 13.9999 3.85501 13.9999H11.2605C12.2834 13.9999 13.1157 13.1677 13.1157 12.1448V8.28066C13.1157 8.1051 12.9734 7.9628 12.7979 7.9628Z",
    fill: "#264F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.682 2H10.3108C10.1353 2 9.99299 2.1423 9.99299 2.31782V3.16534C9.99299 3.34086 10.1353 3.48316 10.3108 3.48316H11.4678L7.11392 7.83701C6.9898 7.96113 6.9898 8.16233 7.11392 8.28649L7.71321 8.88581C7.77283 8.94544 7.85364 8.97891 7.93797 8.97891C8.02225 8.97891 8.10311 8.94544 8.16269 8.88581L12.5166 4.53189V5.68888C12.5166 5.8644 12.6589 6.0067 12.8344 6.0067H13.682C13.8575 6.0067 13.9998 5.8644 13.9998 5.68888V2.31782C13.9998 2.1423 13.8575 2 13.682 2Z",
    fill: "#264F3F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.68d0dcd1.svg";
export { ForwardRef as ReactComponent };